import { ref, onMounted, onUnmounted } from 'vue';

const POLL_INTERVAL_MS = 6 * 60 * 60 * 1000; // 6 hours
const STALE_THRESHOLD_MS = 2 * 24 * 60 * 60 * 1000; // 2 days

const ownBuildTime = import.meta.env.VITE_COMMIT_TIMESTAMP
  ? new Date(import.meta.env.VITE_COMMIT_TIMESTAMP).getTime()
  : null;

export function useStaleVersionCheck() {
  const isStale = ref(false);
  let intervalId: ReturnType<typeof setInterval> | null = null;

  async function check() {
    // VITE_COMMIT_TIMESTAMP is not set in local dev, skip the check entirely
    if (!ownBuildTime) return;

    // If our own build is less than the threshold old, skip checking the server.
    if (Date.now() - ownBuildTime < STALE_THRESHOLD_MS) return;

    // If current build is older than the threshold, check if the server has a newer build.
    try {
      const res = await fetch(`/build_sha.json?_=${Date.now()}`);
      if (!res.ok) return;
      const data = await res.json();
      if (!data.build_time) return;

      const serverBuildTime = new Date(data.build_time).getTime();
      isStale.value = serverBuildTime > ownBuildTime;
    } catch {
      // silent — don't show banner on network errors
    }
  }

  onMounted(() => {
    check();
    intervalId = setInterval(check, POLL_INTERVAL_MS);
  });

  onUnmounted(() => {
    if (intervalId !== null) clearInterval(intervalId);
  });

  return { isStale };
}
